export default "__VITE_ASSET__QT8QN3KT__"